"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButton = exports.MenuButtonDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
var icons_1 = require("../icons");
exports.MenuButtonDefaultProps = {
  isShown: false
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    justify-content: space-between;\n    padding: ", " ", ";\n    align-items: center;\n    align-self: stretch;\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    margin-right: ", ";\n  "], ["\n    display: flex;\n    box-sizing: border-box;\n    justify-content: space-between;\n    padding: ", " ", ";\n    align-items: center;\n    align-self: stretch;\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(2), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(1))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 130px;\n  "], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 130px;\n  "]))),
  landscape: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: 170px;\n  "], ["\n    max-width: 170px;\n  "])))
});
var ChevronIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-left: ", ";\n    top: 1px;\n    position: relative;\n  "], ["\n    flex-shrink: 0;\n    margin-left: ", ";\n    top: 1px;\n    position: relative;\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  ChevronIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ChevronIconStyles)
};
var MenuButton = function (props) {
  var className = props.className,
    children = props.children,
    isShown = props.isShown,
    icon = props.icon,
    hasMenu = props.hasMenu;
  var Icon = icon;
  return react_1.default.createElement(My.Container, {
    className: className
  }, icon && react_1.default.createElement(My.Icon, {
    color: "dark",
    size: 22
  }, react_1.default.createElement(Icon, null)), react_1.default.createElement(My.Label, null, children), hasMenu && false && react_1.default.createElement(My.ChevronIcon, {
    color: "primary",
    size: 12
  }, react_1.default.createElement(icons_1.Icons.ChevronDown, null)));
};
exports.MenuButton = MenuButton;
exports.MenuButton.defaultProps = exports.MenuButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;